import OpenAI, { ClientOptions } from "openai"
import { isBrowser } from "../isbrowser"

declare global {
  type SupportedVectorExtensions = keyof typeof supportedExtensions
  interface Source {
    type: VectorSearchEngines
    sources?: number[]
    chunked?: boolean
    locale?: string
    domain?: string
    distance?: number
    results?: number
    url?: string
    baseUrl?: string
  }
}

const supportedExtensions = {
  "pdf": "application/pdf",
  "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "doc": "application/msword",
  "txt": "text/plain",
  "md": "text/markdown",
  "json": "application/json",
  "xml": "application/xml",
  "xls": "application/vnd.ms-excel",
  "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "csv": "text/csv",
  "jpg": "image/jpeg",
  "png": "image/png",
  "webp": "image/webp",
  "gif": "image/gif",
}


function embeddingClient(apiKey: string) {
  const request: ClientOptions = {
    apiKey,
    dangerouslyAllowBrowser: true,
  }

  if (isBrowser) {
    request.baseURL = `https://signpost-ia-app-qa.azurewebsites.net/decorsify/https://api.openai.com/v1`
  }

  return new OpenAI(request)
}

export const EMBEDDING_MODEL = "text-embedding-3-small"

export async function createEmbedding(input: string, apiKey: string) {

  const embedding = await embeddingClient(apiKey).embeddings.create({
    model: EMBEDDING_MODEL,
    input,
    encoding_format: "float",
  })

  return embedding.data[0].embedding
}

// Many texts in one request, in the order given
export async function createEmbeddingsBatch(inputs: string[], apiKey: string): Promise<number[][]> {
  if (!inputs.length) return []
  const res = await embeddingClient(apiKey).embeddings.create({
    model: EMBEDDING_MODEL,
    input: inputs,
    encoding_format: "float",
  })
  return [...res.data].sort((a, b) => a.index - b.index).map(d => d.embedding)
}




export const documents = {
  supportedExtensions,
  createEmbedding,
}
